export enum Coverage {
    LifeInsurance = 'DI',
    DeathByAccident = 'AD',
    DisabilityByAccident = 'APD',
    APD2 = 'APD2',
    InjuryByAccident = 'AT',
    TemporaryDisabilityByAccident = 'ATD',
    BB = 'BB', //TODO: Need to figure out value.
    CriticalIllness = 'CI',
    TotalAndPermanentDisabilityInsurance = 'TPD',
    TotalAndPermanentLossOfWork = 'WP',
    CriticalIllnessInsuranceExtended = 'CI2',
    CriticalIllnessKidsAdditional = 'CIV',
    CriticalIllnessKids = 'CI3',
    OncoDrop = 'CIc',
    FortyOneCriticalIllnessesExtended = 'CI4',
    TwentyTwoCriticallIllnessKidsAdditional = 'CIV2',
    TwentyTwoCriticalIllnessKids = 'CI5',
    LifeInsuranceD = 'D',
    SickPayCriticalIllnessMain = 'CIHD1',
    SickPayCriticalIllnessExtended = 'CIHD2',
    SickPayCriticalIllnessKids = 'CIHD3',
    DailySubstinenceCriticalIllnessMain = 'CID1',
    DailySubstinenceCriticalIllnessExtended = 'CID2',
    DailySubstinenceCriticalIllnessKids = 'CID3',
    CriticalIllnessMain = 'CI6',
    CriticalIllnessExtended = 'CI7',
    InjuryByAccidentExtended = 'TAV',
}
